import React from "react"
import { connect } from "react-redux"
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { I18n } from 'react-redux-i18n'

import {Redirect} from 'react-router'

import Logo from'../../../images/Het-Veer-weblogo.svg'
import {login} from '../../actions/userActions'

const styles = theme => ({
  resizeLogo: {
    height: '80px'
  },
  container: {
    padding: '1rem'
  },
  textField: {
    width: '100%'
  },
  menu: {
    width: 200
  },
  loginButton: {
    float: 'right'
  },
  logo: {
    width: '100%'
  }
})

class Login extends React.Component {
  state = {
    username: 'Username',
    password: 'Password'
  }

  usernameChanged = (e) => {
    this.setState({username: e.target.value})
  }

  passwordChanged = (e) => {
    this.setState({password: e.target.value.toUpperCase()})
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.loginEvent()
    }
  }

  moveLogo = (e) => {
    document.getElementById("logo").classList.add("Login-resizeLogo-1");
  }

  loginEvent = (e) => {
    this.props.dispatch(login(this.state.username, this.state.password))
  }
  render() {
    const { classes } = this.props

    if(this.props.user.loggedIn){
      if(this.props.user.user.preference === "w"){
        return <Redirect to="/week"/>
      }else{
        return <Redirect to="/month"/>
      }
    }

    return (
      <Grid container className={classes.container} justify="center">
        <Grid item xs={12} md={6}>
          <img
            id="logo"
            src={Logo}
            alt="logo"
            className={classes.logo}
           />
       </Grid>
       <Grid item xs={12} md={12}>
          <TextField
            id="name"
            label={I18n.t('login.username')}
            value={this.state.name}
            onChange={this.usernameChanged}
            onKeyPress={this.handleKeyPress}
            onClick={this.moveLogo}
            margin="normal"
            className={classes.textField}
          />
          <TextField
            id="password-input"
            label={I18n.t('login.password')}
            type="password"
            onChange={this.passwordChanged}
            onKeyPress={this.handleKeyPress}
            margin="normal"
            className={classes.textField}
          />
          <Button variant="contained" color="primary" className={classes.loginButton} onClick={this.loginEvent}>
            {I18n.t('login.login')}
          </Button>
        </Grid>
      </Grid>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login))



// WEBPACK FOOTER //
// ./src/js/components/pages/Login.js